import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'cmps-alert',
    template: ` <div class="cmps-alert--content">
            <ng-content></ng-content>
        </div>
        <div *ngIf="dismissible">
            <button
                class="cmps-icon-button--no-bg"
                cmpsIconButton
                (click)="closed.emit()"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>`,
    host: {
        class: 'cmps-alert',
        '[style.border-color]': 'borderColor',
        '[style.background-color]': 'backgroundColor',
    },
})
export class CmpsAlertComponent implements OnInit, OnDestroy {
    @Input() dismissible: boolean;
    @Input() borderColor: string;
    @Input() backgroundColor: string;
    @Output() closed: EventEmitter<void>;

    /** @private */ _sub: Subscription;

    constructor(
        private readonly _ngZone: NgZone,
        private readonly _el: ElementRef<HTMLElement>,
    ) {
        this.dismissible = true;
        this.closed = new EventEmitter();
    }

    ngOnInit(): void {
        this._sub = this._ngZone.onStable
            .pipe(
                tap(() => {
                    // later change to jss or css variables or something
                    const buttons = Array.from<HTMLElement>(
                        this._el.nativeElement.querySelectorAll(
                            '.cmps-alert--content button',
                        ),
                    );
                    buttons.forEach((e) => {
                        e.style.borderColor = this.borderColor;
                    });
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._sub && this._sub.unsubscribe();
        this.closed.complete();
    }
}
